@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}
input[type='date'] {
  appearance: none;
}
